export default "__VITE_ASSET__8f001f31__"